<template>
  <ion-page>
    <ion-content :fullscreen="true">
      <div class="w-screen h-screen flex items-center justify-center">
        <loading-state />
      </div>
    </ion-content>
  </ion-page>
</template>

<script>
import { IonContent, IonPage } from "@ionic/vue";
import { Browser } from "@capacitor/browser";
import { defineComponent } from "vue";
import { useAuth0 } from "@auth0/auth0-vue";
import LoadingState from "@/components/common/LoadingState.vue";
import { useAuthLogin } from "@/composables/useAuthLogin";

export default defineComponent({
  name: "LoginPage",
  components: {
    IonContent,
    IonPage,
    LoadingState,
  },

  setup() {
    const { isAuthenticated } = useAuth0();
    const { login, isBrowserOpen } = useAuthLogin({ useDeepLink: true });

    return {
      isAuthenticated,
      login,
      isBrowserOpen,
    };
  },
  async mounted() {
    if (!this.isAuthenticated) {
      await this.login();
    } else {
      this.$router.push("/home");
    }
  },
  async created() {
    Browser.addListener("browserFinished", async () => {
      console.log("Browser finished - user returned from Auth0");
      this.isBrowserOpen = false;

      // Check if callback was already handled by appUrlOpen
      // If so, appUrlOpen handles everything (closing browser, navigation)
      const callbackHandled = sessionStorage.getItem("callbackHandled");
      if (callbackHandled === "true") {
        console.log(
          "Callback already handled by appUrlOpen - skipping browserFinished logic"
        );
        sessionStorage.removeItem("callbackHandled");
        return;
      }

      // Only handle case where browser was closed manually BEFORE completing auth
      // (i.e., no callback URL was received)
      console.log(
        "Browser closed without callback URL - user may have cancelled"
      );
      // Wait a moment for authentication state to update
      await new Promise((resolve) => setTimeout(resolve, 500));

      // If user is not authenticated, reopen the browser
      if (!this.isAuthenticated) {
        console.log("User not authenticated - reopening in-app browser");
        await this.login();
      }
    });
  },
});
</script>
